module.exports = __webpack_public_path__ + "img/role3.80580de3.png";